/*
 *
 * ReceptionForm14691
 *
 */

import React from 'react';
import AdvancedForm from 'containers/AdvancedForm';
import {WITH_CHIP, WITHOUT_CHIP} from 'domain/Data/PassType/constants';
import {
    ON_CAR_ENTRY, ON_PASS_MAKING, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL,
    ON_VISIT, SERVICE, CARRYING_OUT_WORKS
} from 'domain/Data/RequestType/constants';
import {accessLevel} from '../../../domain/Data/VozdvizhenkaAccessLevel/constants';
import {CREATED, ON_TERRITORY, REJECTED} from 'domain/Data/RequestStatus/constants';
import {PASSPORT} from 'domain/Data/DocumentType/constants';
import {validateCarNumber} from 'utils/validators';
import {formField} from 'domain/typeConstants/form';
import * as entities from 'domain/Data/constants';
import {validateExpirationDate, calculateMaxExpirationDate} from '../utils';
import {RECEPTION_REQUESTS_FORM} from 'pages/Requests/ReceptionView/constants';
import {getValueFromLocalStorage} from 'utils/localStorage';
import {GLOBAL_USER_KEY} from 'global-constants';
import {REQUESTS} from 'domain/Data/constants';
import {COMPANY_ARCHIVE_STATUS} from 'pages/Companies/ReceptionView/constants';
import {groupRequestVisitorsDataHelperText, visitorFullNameLabel} from 'pages/Requests/common/fields';
import {helperTextClassName} from "../common/formClassNames";


export class ReceptionForm14691 extends React.PureComponent {

    getClassNames() {
        return {
            helperText: helperTextClassName,
        };
    }

    getFields() {
        const currentDate = new Date();

        return [
            {
                name: 'author',
                visible: false,
                initialValue: (values, mode, user) => user.id,
            },
            {
                name: 'arrivalDate',
                type: 'date',
                visible: false,
                calculatedValue: (values, mode) => {
                    if ((mode === 'add' || mode === 'copy') && values.type === ON_VISIT) {
                        return currentDate
                    }
                    if (mode === 'edit' && values.type === ON_VISIT && values.passNumber) {
                        return currentDate
                    }
                    return null
                }
            },
            {
                name: 'departureDate',
                visible: false,
                initialValue: () => null,
            },
            {
                name: 'number',
                label: '№',
                visible: (currentValues, initialValues, mode) => mode === 'edit',
                disabled: true,
            },
            {
                name: 'status',
                type: 'select',
                label: 'Статус',
                entityName: 'requestStatuses',
                disabled: (currentValues, initialValues, mode) => mode === 'edit' && currentValues.type === ON_PROPERTY_BRINGING,
                visible: (currentValues, initialValues, mode) => mode === 'edit',
                calculatedValue: (values, mode) => {
                    if (mode === 'add' || mode === 'copy') {
                        return values.type === ON_VISIT ? ON_TERRITORY : CREATED;
                    }
                    return values.status;
                },
                visibleOptions: (currentValues, initialValues, mode, user, entities) => {
                    const status = entities.get('requestStatuses').valueSeq().toJS();
                    if (status && (currentValues.status === REJECTED || currentValues.status === CREATED)) {
                        return status.filter(item => item.id !== ON_TERRITORY).map((item) => item.id);
                    }
                },
                orderBy: 'name',
            },
            {
                name: 'type',
                type: 'select',
                label: 'Вид',
                required: true,
                entityName: 'requestTypes',
                disabled: (currentValues, initialValues, mode) => mode === 'edit' && currentValues.type === ON_PROPERTY_BRINGING,
                initialValue: (values, mode) => {
                    if (mode === 'add') {
                        return ON_VISIT;
                    }
                    return values.type;
                },
                orderBy: 'order',
                clearErrorsOnChange: true,
                helperText: (values) => values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL ?
                    'Въезд во внутренний двор только для разгрузки продолжительностью не более 1 часа' : null,
            },
            {
                name: 'longterm',
                type: 'checkbox',
                label: (values) => values.type === ON_PASS_MAKING ? 'Срок действия' : 'Долгосрочная',
                visible: (values) => values.type !== SERVICE,
            },
            {
                name: 'visitDate',
                type: 'date',
                label: 'Дата',
                required: true,
                visible: (currentValues, initialValues, mode) => mode === 'view' || currentValues.type !== SERVICE,
                initialValue: currentDate,
                min: (currentValues, initialValues) => new Date(initialValues.visitDate) < currentDate ?
                    new Date(initialValues.visitDate) : currentDate,
                disabled: (currentValues) => currentValues.type === SERVICE,
                calculatedValue: (values) => {
                    const visitDate = new Date(values.visitDate);
                    return new Date(visitDate.getFullYear(), visitDate.getMonth(), visitDate.getDate(), currentDate.getHours()
                    )
                },
            },
            {
                name: 'expirationDate',
                type: 'date',
                label: (values) => values.type === ON_PASS_MAKING ? 'Дата окончания пропуска' : 'Дата окончания',
                required: (values) => values.longterm,
                visible: (values) => values.longterm && values.type !== SERVICE,
                initialValue: (values, mode) => {
                    if (mode === 'copy') {
                        return new Date(values.expirationDate) > currentDate ?
                            new Date(values.expirationDate) : currentDate;
                    }
                    return null;
                },
                calculatedValue: (values) => values.longterm ? values.expirationDate : null,
                min: (values) => new Date(values.visitDate) < currentDate ?
                    new Date(values.visitDate) : currentDate,
                validate: validateExpirationDate,
                max: calculateMaxExpirationDate,
            },
            {
                name: 'isGroupRequest',
                type: 'checkbox',
                label: 'Групповая заявка',
                rowBreakBefore: (values) => values.type !== SERVICE,
                visible: (values) => values.type === ON_VISIT || values.type === ON_CAR_ENTRY || values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'groupRequestVisitorsData',
                label: 'Список посетителей',
                multiline: true,
                helperText: groupRequestVisitorsDataHelperText(),
                visible: (values) => values.isGroupRequest && values.type !== SERVICE,
                required: (values) => values.isGroupRequest && values.type === ON_VISIT,
                grid: {sm: 12},
                rowBreakBefore: (values) => values.isGroupRequest && values.type !== SERVICE,
            },
            {
                name: 'vozdvizhenkaTime',
                type: formField.SELECT,
                entityName: entities.TIMES,
                label: 'Время доступа',
                visible: (values) => values.type === ON_PASS_MAKING || values.type === CARRYING_OUT_WORKS,
                required: (values) => values.type === ON_PASS_MAKING,
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'workType',
                label: 'Вид',
                type: formField.SELECT,
                entityName: entities.WORK_TYPES,
                visible: (values) => values.type === CARRYING_OUT_WORKS,
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
                rowBreakAfter: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'companyName',
                label: (values) => values.type === CARRYING_OUT_WORKS ? 'Подрядчик' : 'Из какой компании',
                visible: true,
                required: (values) => values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
            },


            {
                type: formField.SELECT,
                entityName: entities.ISSUE_REASONS,
                name: 'issueReason',
                label: 'Причина выдачи',
                visible: (values) => values.type === ON_PASS_MAKING,
                required: (values) => values.type === ON_PASS_MAKING,
                orderBy: 'id',
            },
            {
                name: 'passType',
                type: 'select',
                label: 'Вид пропуска',
                entityName: 'passTypes',
                visible: (values) => values.type === ON_PASS_MAKING,
                required: (values) => values.type === ON_PASS_MAKING,
                visibleOptions: () => [WITH_CHIP, WITHOUT_CHIP],
            },
            {
                name: 'visitorFullName',
                label: visitorFullNameLabel,
                type: 'dadata',
                dadataType: 'NAME',
                dadataParts: ['SURNAME', 'NAME', 'PATRONYMIC'],
                autoFocus: (currentValues, initialValues, mode) => mode === 'add',
                visible: (values) => !values.isGroupRequest && values.type !== SERVICE && values.type !== CARRYING_OUT_WORKS,
                required: (values) => (!values.isGroupRequest && values.type === ON_VISIT)
                    || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                rowBreakBefore: (values) => !values.isGroupRequest && values.type !== SERVICE,
            },
            {
                name: 'company',
                type: 'autocomplete',
                label: 'Арендатор',
                entityName: 'companies',
                filterBy: `!status.name.contains("${COMPANY_ARCHIVE_STATUS}") or (status = null)`,
                orderBy: 'name',
                numberInQueueFromEnd: 1,
                initialValue: (values, mode, user) => user.companyId,
                rowBreakAfter: (values) => values.type === ON_VISIT ||
                    values.type === ON_CAR_ENTRY || values.type === ON_PASS_MAKING ||
                    values.type === SERVICE,
                required: true,
            },
            {
                name: 'responsibleFromContractor',
                label: (values) => values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL
                    ? 'Телефон водителя' : 'Ответственный от подрядчика',
                visible: (values) => values.type === CARRYING_OUT_WORKS
                    || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                required: true,
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'responsibleFromContractorPhone',
                label: (values) => values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL
                    ? 'Телефон ответственного (заявителя)' : 'Телефон отв. подрядчика',
                visible: (values) => values.type === CARRYING_OUT_WORKS
                    || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                required: true,
            },
            {
                name: 'nonstandardCarNumber',
                type: 'checkbox',
                label: 'Нестандартный № авто',
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
                rowBreakAfter: (values) => values.type === ON_CAR_ENTRY ||
                    values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL || values.type === CARRYING_OUT_WORKS,
                visible: (values) => (values.type === ON_CAR_ENTRY ||
                        values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL || values.type === CARRYING_OUT_WORKS)
                    && !values.isGroupRequest,
            },
            {
                name: 'documentType',
                type: 'select',
                label: 'Вид документа',
                initialValue: PASSPORT,
                entityName: 'documentTypes',
                visible: (values) => values.type !== ON_CAR_ENTRY && values.type !== ON_PASS_MAKING && values.type !== CARRYING_OUT_WORKS &&
                    values.type !== SERVICE && !values.isGroupRequest,
                calculatedValue: (values) => values.isGroupRequest ? PASSPORT : values.documentType,
                rowBreakBefore: true,
            },
            {
                name: 'documentDetails',
                label: 'Серия, № документа',
                visible: (values) => !values.isGroupRequest && values.type !== ON_PASS_MAKING && values.type !== CARRYING_OUT_WORKS
                    && values.type !== ON_CAR_ENTRY &&
                    values.type !== SERVICE,
            },
            {
                name: 'passNumber',
                label: '№ пропуска',
                visible: (values) => values.type === ON_VISIT ||
                    values.type === ON_PASS_MAKING,
                initialValue: () => null,
            },
            {
                name: 'carNumber',
                label: '№ автомобиля',
                required: (values) => values.type === ON_CAR_ENTRY && !values.isGroupRequest,
                visible: (values) => (values.type === ON_CAR_ENTRY ||
                        values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL || values.type === CARRYING_OUT_WORKS)
                    &&
                    !values.isGroupRequest,
                normalize: (value) => value ? value.replace(' ', '') : value,
                validate: validateCarNumber,
                rowBreakBefore: true,
            },
            {
                name: 'carModelText',
                label: 'Марка автомобиля',
                visible: (values) => (values.type === ON_CAR_ENTRY ||
                        values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL || values.type === CARRYING_OUT_WORKS)
                    &&
                    !values.isGroupRequest,
            },
            {
                name: 'vozdvizhenkaAccessLevel',
                type: formField.SELECT,
                entityName: entities.VOZDVIZHENKA_ACCESS_LEVEL,
                label: (values) => values.type === ON_PASS_MAKING ? 'Уровень доступа' : 'Пронос через дебаркадер',
                visible: (values) => values.type === ON_PASS_MAKING || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                required: (values) => values.type === ON_PASS_MAKING || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                visibleOptions: (values) => values.type === ON_PASS_MAKING ? [accessLevel.TOURNIQUET, accessLevel.ADDITIONAL]
                    : [accessLevel.YES, accessLevel.NO],
                orderBy: 'id',
            },
            {
                name: 'vodvizhenkaAccessRight',
                label: 'Дополнительный доступ',
                multiline: true,
                visible: (values) => values.type === ON_PASS_MAKING,
                required: (values) => values.vozdvizhenkaAccessLevel === accessLevel.ADDITIONAL,
                rowBreakBefore: true,
            },
            {
                name: 'parking',
                type: 'select',
                label: 'Парковка',
                entityName: 'parkings',
                visible: (values) => values.type === ON_CAR_ENTRY,
                rowBreakBefore: true,
            },
            {
                name: 'parkingPlace',
                label: '№ места',
                visible: (values) => values.type !== ON_VISIT && values.type !== ON_PASS_MAKING && values.type !== SERVICE
                    && values.type !== CARRYING_OUT_WORKS,
                initialValue: () => null,
            },
            {
                name: 'materialValuesData',
                label: 'Данные мат. ценностей',
                helperText: 'наименование, кол-во, ед.изм.',
                grid: {sm: 12},
                required: true,
                visible: (values) => values.type === ON_PROPERTY_BRINGING ||
                    values.type === ON_PROPERTY_REMOVAL,
            },
            {
                name: 'whoMeets',
                label: 'Кто встречает',
                visible: (values) => values.type === ON_VISIT,
                rowBreakBefore: true,
            },
            {
                name: 'service',
                type: 'select',
                label: 'Сервис',
                entityName: 'services',
                visible: (values) => values.type === SERVICE,
                rowBreakBefore: true,
            },
            {
                name: 'whatHappened',
                label: (values) => values.type === CARRYING_OUT_WORKS ? 'Наименование/Характер работ' : 'Что нужно сделать',
                multiline: false,
                visible: (values) => values.type === SERVICE || values.type === CARRYING_OUT_WORKS,
                grid: {sm: 12},
            },
            {
                name: 'assignee',
                type: 'select',
                label: 'Исполнитель',
                entityName: 'employees',
                orderBy: 'name',
                cached: false,
                visible: false,
                rowBreakAfter: (values) => values.type === SERVICE,
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.assignee;
                },
            },
            {
                name: 'executionDate',
                type: 'date',
                label: 'Дата выполнения факт',
                required: true,
                visible: false,
                min: (currentValues, initialValues) => new Date(initialValues.visitDate) < currentDate
                    ? new Date(initialValues.visitDate) : currentDate,
                rowBreakBefore: true,
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.executionDate;
                },
            },
            {
                name: 'executionTerm',
                type: 'date',
                label: 'Срок исполнения',
                required: true,
                visible: false,
                min: () => currentDate,
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.executionTerm;
                },
            },
            {
                name: 'whereHappened',
                label: 'Где произошло',
                visible: (values) => values.type === SERVICE,
            },
            {
                name: 'implementationReport',
                label: 'Отчет о выполнении',
                visible: (values) => values.type === SERVICE,
                grid: {sm: 12},
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.implementationReport;
                },
            },
            {
                name: 'file',
                label: 'Файл',
                type: 'file',
                visible: (values) => values.type === SERVICE ||
                    values.type === ON_PASS_MAKING || values.type === CARRYING_OUT_WORKS
                    || values.type === ON_PROPERTY_BRINGING,
                rowBreakBefore: true,
            },
            {
                name: 'workPlace',
                label: 'Место проведения',
                visible: (values) => values.type === CARRYING_OUT_WORKS,
                required: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'note',
                label: 'Примечание',
                grid: {sm: 12},
                visible: (values) => values.type !== SERVICE,
            },
            {
                name: 'managementCompanyComment',
                label: 'Комментарий УК',
                visible: (values, initialValues, mode) => mode === 'view' || mode === 'edit',
                grid: {sm: 12},
                initialValue: (values, mode) => {
                    if (mode === 'copy') {
                        return null;
                    }
                    return values.managementCompanyComment;
                },
                required: (currentValues) => currentValues.status === REJECTED,
            },
            {
                name: 'needDisableOrChangeSystem',
                label: 'Необходимость отключения или изменения работы инженерных систем и оборудования здания',
                type: formField.CHECKBOX,
                visible: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'agreedEmployee',
                type: formField.AUTOCOMPLETE,
                label: 'Согласовал',
                visible: (currentValues, initialValues, mode) => mode === 'edit' || mode === 'view',
                entityName: 'employees',
                disabled: true,
                rowBreakBefore: true,
                initialValue: (values) => values.agreedEmployee,
            },
        ];
    }

    render() {
        const accountId = getValueFromLocalStorage(GLOBAL_USER_KEY).accountId
        return (
            <AdvancedForm
                name={RECEPTION_REQUESTS_FORM}
                entityName={REQUESTS}
                classNames={this.getClassNames()}
                fields={this.getFields()}
                useAsyncValidate
                accountId={accountId}
                {...this.props}
            />
        );
    }

}

export default ReceptionForm14691